import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './components/toast/toast.component';
import { ThemeService } from './services/theme.service';
import { UiSettingsService } from './services/ui-settings.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  template: '<router-outlet /><app-toast />',
})
export class App {
  private readonly theme = inject(ThemeService);
  private readonly uiSettings = inject(UiSettingsService);

  constructor() {
    this.uiSettings.load();
  }
}
